//dependencias
import React, { Component } from 'react';

//componentes
import Inventario from './inventario';
class Index extends Component {
    render() {
        return(
            <div className="Inicio">
                <Inventario /> 
            </div>
        );
    }
}
export default Index;